import { DegradationCurveParameters } from 'src/app/degradation/models/degradation-curve';

export class DegradationUtil {

  public static isOverthickness(p: DegradationCurveParameters): boolean {
    if(p == null) return false;

    return this.isOverthicknessValue(p.EstimatedThickness, p.OriginalThickness)
  }

  public static isOverthicknessValue(v: number, originalThickness: number): boolean {
    const value = Number((v).toFixed(2))
    const overThickness = Number((originalThickness * 1.05).toFixed(2))

    if (value >= overThickness) {
      return true
    }
    else {
      return false
    }
  }

  public static updateDegradationParameters(p: DegradationCurveParameters, referenceDate: Date): DegradationCurveParameters {
    const d1 = new Date(new Date(p.Date).getFullYear(), new Date(p.Date).getMonth(), new Date(p.Date).getDate());
    const d2 = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate());

    if (d1.getTime() != d2.getTime()){
      p.Date = referenceDate
      p.Time = ( new Date(referenceDate).getTime() - new Date(p.BuildingDate).getTime() ) / (1000*60*60*24)
      p.CorrosionRate = this.updateCorrosionRate(p)
      p.EstimatedLostThickness = this.updateEstimatedLostThickness(p)
      p.EstimatedThickness = this.updateEstimatedThickness(p)
      p.RemainingLife = this.updateRemainingLife(p)
      p.AbsoluteDegradation = this.updateAbsoluteDegradation(p)
      p.RelativeDegradation = this.updateRelativeDegradation(p)
    }
    return p
  }

  private static updateCorrosionRate(p: DegradationCurveParameters): number {
    if (p.CurveType == "Linear") {
      const slope = p.CurveParameters[1]

      corrosionRate = slope * 365
      p.CorrosionRate = corrosionRate
    }
    else if (p.CurveType == "Exponential") {
      const a = p.CurveParameters[0]
      const b = p.CurveParameters[1]

      var corrosionRate = (365 * a * b * Math.pow(p.Time, b - 1))
      p.CorrosionRate = corrosionRate
    }

    return p.CorrosionRate
  }

  private static updateEstimatedLostThickness(p: DegradationCurveParameters): number {
    p.EstimatedLostThickness = 0
    if(p.CurveType == "Linear"){
      const intercept = p.CurveParameters[0]
      const slope = p.CurveParameters[1]

      var estimatedLostThickness = p.Time * slope
      p.EstimatedLostThickness = estimatedLostThickness
     }
    else if (p.CurveType == "Exponential"){
      const a = p.CurveParameters[0]
      const b = p.CurveParameters[1]

      var estimatedLostThickness = a * Math.pow(p.Time, b )
      p.EstimatedLostThickness = estimatedLostThickness
    }

    return p.EstimatedLostThickness
  }

  private static updateEstimatedThickness(p: DegradationCurveParameters): number {
    p.EstimatedThickness = p.OriginalThickness - p.EstimatedLostThickness

    if (p.EstimatedThickness < 0) p.EstimatedThickness = 0

    return p.EstimatedThickness
  }

  private static updateRemainingLife(p: DegradationCurveParameters): number {
    if (p.CorrosionRate <= 0) {
      return Infinity
    }

    const excessiveCorrosionThickness = p.RuleThickness * (1 - (p.WastageAllowance / 100));
    const lostThicknessLimit = p.OriginalThickness - excessiveCorrosionThickness;

    if (p.CurveType == "Linear")
    {
      const intercept = p.CurveParameters[0];
      const slope = p.CurveParameters[1];

      const lifeTime = lostThicknessLimit / slope;
      p.RemainingLife = ((lifeTime - p.Time) / 365);
    }
    else if (p.CurveType == "Exponential")
    {
      const a = p.CurveParameters[0];
      const b = p.CurveParameters[1];
      const base = lostThicknessLimit / a;
      const exponent = 1 / b;

      const lifeTime = Math.pow(base, exponent);
      p.RemainingLife = ((lifeTime - p.Time) / 365);
    }

    // if (p.RemainingLife < 0) p.RemainingLife = 0;

    return p.RemainingLife
  }

  private static updateAbsoluteDegradation(p: DegradationCurveParameters): number {
    p.AbsoluteDegradation = 100 * (p.RuleThickness - p.EstimatedThickness) / p.RuleThickness;

    return p.AbsoluteDegradation
  }

  private static updateRelativeDegradation(p: DegradationCurveParameters): number {
    p.RelativeDegradation = 100 * p.AbsoluteDegradation / p.WastageAllowance;
    return p.RelativeDegradation
  }
}
